import { ButtonLink } from '@designsforhealth/dfh-react-components'
import React, { BaseSyntheticEvent, useCallback, useState } from 'react'
import styled from 'styled-components'
import { ModalProps } from 'styled-react-modal'

import { truncatedNonHtmlText } from '../../lib/cart/item'
import { CartItem } from '../../lib/cart/types'
import CartItemDescriptionModalContents from './CartItemDescriptionModalContents'

export interface ButtonLinkElementProps {
  children?: React.ReactNode
  className?: string
  onClick?: (e?: BaseSyntheticEvent) => void
}

const StyledButtonLink = styled(ButtonLink)`
  bottom: 1px;
  display: inline;
  padding: 0;
  text-decoration: underline;
  text-transform: none;
`

export interface CartItemDescriptionProps {
  className?: string
  item: CartItem
  modalComponent: React.ElementType<ModalProps>
}

const CartItemDescription: React.FC<CartItemDescriptionProps> = ({
  className,
  item,
  modalComponent,
}) => {
  const [openShortDescriptionModal, setOpenShortDescriptionModal] = useState(false)
  const shortDescription = item.item_attributes?.short_description

  const handleClose = useCallback(() => setOpenShortDescriptionModal(false), [])

  if (!shortDescription) {
    return null
  }

  return (
    <div className={className}>
      <p className="small-paragraph">
        {truncatedNonHtmlText({ text: shortDescription })}
        ...{' '}
        <StyledButtonLink onClick={() => setOpenShortDescriptionModal(true)}>
          View more
        </StyledButtonLink>
      </p>
      {React.createElement(
        modalComponent,
        {
          allowScroll: true,
          isOpen: openShortDescriptionModal,
          onBackgroundClick: handleClose,
          onEscapeKeydown: handleClose,
        },
        <CartItemDescriptionModalContents
          description={shortDescription}
          handleClose={handleClose}
          item={item}
        />,
      )}
    </div>
  )
}

const StyledCartItemDescription = styled(CartItemDescription)`
  p {
    margin-bottom: 8px;
    margin-top: 4px;
    padding: 0;
  }
`

export default StyledCartItemDescription
